export const RBAC_SYMBOL = Symbol.for("vue-rbac");
